import { Button, Container, Paper, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { X } from 'tabler-icons-react';

function ExpiredResetLink() {
  const navigate = useNavigate();

  return (
    <>
      <Container
        fluid
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Paper
          shadow='xs'
          p='xl'
          mx='auto'
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 400,
          }}
        >
          <Paper mb='sm'>
            <X color='red' size={100} />
          </Paper>
          <Title order={2} mb='sm'>
            Password Reset Link Expired
          </Title>
          <Text align='center' color='gray' size='sm' mb='lg'>
            Oops! The password reset link you've clicked is no longer active. To
            reset your password, please click the button below to request a new
            link on the forgot password page. Thanks for your understanding!
          </Text>
          <Button
            onClick={() => {
              navigate('/forgot-password');
            }}
          >
            Request a new link
          </Button>
        </Paper>
      </Container>
    </>
  );
}

export default ExpiredResetLink;
